import NotFound from "@/components/AppRouter/NotFound";
import { PageHeader } from "@/components/PageHeader/PageHeader";
import Table from "@/components/Table/Table";
import TableHeader from "@/components/TableHeader/TableHeader";
import { useGetCompanies } from "@/hooks/useAdmin";
import { useUserSettings } from "@/hooks/useUserSettings";
import { LinkOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { Link } from "react-router-dom";

export default function UserAdmin() {
  const { data: userSettings } = useUserSettings();
  const {
    data: companies,
    isLoading: companiesLoading,
    isFetching: companiesFetching,
  } = useGetCompanies();

  if (userSettings && userSettings.role !== "root_admin") {
    return <NotFound />;
  }

  return (
    <Flex
      vertical
      gap={12}
    >
      <PageHeader title={"Companies"} />
      <div>
        <TableHeader
          left={
            <Flex gap={12}>
              <Link to="/admin/companies/new">
                <Button icon={<PlusOutlined />}>Add company</Button>
              </Link>
              <Link to={`/admin/companies/${userSettings?.company_id}`}>
                <Button icon={<LinkOutlined />}>My company</Button>
              </Link>
            </Flex>
          }
        />
        <Table
          loading={companiesLoading || companiesFetching}
          data={companies}
          columns={[
            { label: "ID", key: "id" },
            {
              label: "Name",
              key: "name",
            },
            {
              label: "Type",
              key: "type",
            },
          ]}
          rowLink={(record) => `/admin/companies/${record.id}`}
          rowKey={"id"}
        />
      </div>
    </Flex>
  );
}
